import { render, staticRenderFns } from "./TasksLoading.vue?vue&type=template&id=3dff52aa&"
import script from "./TasksLoading.vue?vue&type=script&lang=js&"
export * from "./TasksLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports